import CalendarTodayRounded from '@mui/icons-material/CalendarTodayRounded';
import CheckRounded from '@mui/icons-material/CheckRounded';
import CloseRounded from '@mui/icons-material/CloseRounded';
import ErrorOutlineRounded from '@mui/icons-material/ErrorOutlineRounded';
import EventBusyRounded from '@mui/icons-material/EventBusyRounded';
import FlagRounded from '@mui/icons-material/FlagRounded';
import ScheduleRounded from '@mui/icons-material/ScheduleRounded';
import StarRounded from '@mui/icons-material/StarRounded';
import './StatusBadge.module.scss';

const STATUS = {
  planned: [CalendarTodayRounded, 'Planned'],
  today: [CalendarTodayRounded, 'Today'],
  onTrack: [CheckRounded, 'On Track'],
  late: [ScheduleRounded, 'Running Late'],
  overdue: [ErrorOutlineRounded, 'Overdue'],
  started: [FlagRounded, 'Started'],
  finished: [FlagRounded, 'Finished'],
  cancelled: [CloseRounded, 'Cancelled'],
  missed: [EventBusyRounded, 'Missed'],
  default: [StarRounded, 'Default'],
};

// The design system's StatusBadge: where a Plan or Activity stands, always
// as an icon and a word, never colour alone.
const StatusBadge = ({ status, label }) => {
  const [Icon, text] = STATUS[status] ?? STATUS.planned;
  return (
    <span className={`ts-badge ts-badge--${status}`}>
      <Icon aria-hidden="true" />
      <span>{label ?? text}</span>
    </span>
  );
};

export default StatusBadge;
